import React from 'react'
import MaterialTable from 'material-table';
import { darken, makeStyles, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT } from '../../constants';
import { BarChart } from '../charts/BarChart';


const {color_enc_table,color_nav_letter_enc_table}= COLORS_PROJECT; //color_nav,color_nav_letter,
const useStyles = makeStyles(()=>({
    paper: {  
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
}))

export const ReportDescriptionTable = () => {

    const classes = useStyles();
    
    const {data} = useSelector(state => state.print)
    const {info_alertas=[]}= data
    
    const dataChart = info_alertas.map(numberAlert =>(numberAlert.total_alertas)) 
    const {colorPoints,nameAlerts} = useSelector(state => state.auth) //nameColors
    const arrColors = colorPoints.split(",")
    //const arrNames = nameColors.split(",")
    const arrNamesAlerts = nameAlerts.split(",")

    return (
        <>
            <Paper className={classes.paper}>
                <MaterialTable
                
                    columns = {[
                        {
                            field: 'nivel', 
                            title: 'Nivel Alerta',
                            render: rowData => {
                                switch (rowData.nivel) {
                                    case 1:
                                        return `${arrNamesAlerts[0]}`
                                    case 2: 
                                        return `${arrNamesAlerts[1]}`
                                    case 3: 
                                        return `${arrNamesAlerts[2]}`
                                    default:
                                        return '';
                                }
                            }
                        },
                        {field: 'total_alertas', title: 'Total Alertas'},
                        {field: 'acum_horas', title: 'Acumulado horas'},
                    ]}

                    data = {info_alertas}

                    options={{
                        paging: false,
                        search: false,
                        showTitle: false,
                        toolbar: false,
                        headerStyle: {
                            backgroundColor: darken(color_enc_table,0.2),
                            color: color_nav_letter_enc_table,
                            fontWeight: 'bold',
                        },
                        rowStyle: rowData =>{
                            switch (rowData.nivel) {
                                case 3:
                                    return {backgroundColor: arrColors[3]};
                                case 2:
                                    return {backgroundColor: arrColors[2]};
                                case 1:
                                    return {backgroundColor: arrColors[1]};    
                                default:
                                    return {};
                            }
                        },
                    }}

                    
                />
            </Paper>
                

            <Paper className={classes.paper} style = {{marginTop: '15px'}}>
                <BarChart 
                    dataChart={dataChart} 
                    size={200}
                    color_alarm_yellow={arrColors[1]}
                    color_alarm_orange={arrColors[2]}
                    color_alarm_red={arrColors[3]}
                    nameColor1={arrNamesAlerts[0]}
                    nameColor2={arrNamesAlerts[1]}
                    nameColor3={arrNamesAlerts[2]}
                />
            </Paper>
        </>
    )
}
